import { Button } from 'antd';
import React from 'react';
import { ModalHandler } from 'components/Modal';

import './style.scss';

const WarningModal: React.FC<ModalHandler> = ({ close }) => {
    return (
        <div className="plaid-warning-modal-root">
            <p>{__('You can link up to 4 bank accounts at one time.')}</p>
            <Button
                block
                type="primary"
                onClick={() => {
                    close();
                }}>
                {__('OK')}
            </Button>
        </div>
    );
};

export default WarningModal;
